import { CaseField } from "./caseField"

export interface RecordUserAssignment {
    userId: string
    fieldId: string
    date: string
    hours: number
    remainingHoursOnDate: number
}

export enum AssignmentOperation {
	Set = 0,
	NextDay = 1,
	AutoFill = 2
}

export interface AssignedHours {
	hoursFieldId: string,
	userRoleFields: CaseField[],
	hours: number,
	assignedTime: number,
	unassignedTime: number,
}
